// Lien de proposition : tout est dans l’adresse (JSON → UTF-8 → base64url), rien n’est stocké.
import { MIN, isValidZone } from './time';
import { label, placeOf, type Contact, type Profile } from './contact';

export interface ProposalPayload {
  v: 1;
  /** Nom de l’expéditeur affiché au client. */
  f: string;
  /** Fuseau de l’expéditeur. */
  z: string;
  /** Ville de l’expéditeur. */
  c: string;
  /** E-mail de réception des confirmations. */
  e: string;
  /** Durée en minutes. */
  d: number;
  /** Débuts des créneaux (ms UTC). */
  s: number[];
  /** Titre. */
  t: string;
  /** Lien visio, facultatif. */
  m?: string;
}

export function b64urlEncode(value: unknown): string {
  const bytes = new TextEncoder().encode(JSON.stringify(value));
  let bin = '';
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function b64urlDecode(s: string): unknown {
  const b = s.replace(/-/g, '+').replace(/_/g, '/');
  const padding = b.length % 4 ? '='.repeat(4 - (b.length % 4)) : '';
  const bin = atob(b + padding);
  const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0));
  return JSON.parse(new TextDecoder().decode(bytes));
}

export function proposalPayload(slots: Array<{ start: number; end: number; people: Contact[] }>, me: Profile, meet?: string): ProposalPayload {
  const first = slots[0];
  if (!first) throw new Error('Aucun créneau.');
  const d = Math.round((first.end - first.start) / MIN);
  const p: ProposalPayload = {
    v: 1,
    f: me.displayName || '',
    z: me.tz,
    c: placeOf(me),
    e: me.replyEmail || '',
    d,
    s: slots.map((x) => x.start),
    t: 'Appel · ' + first.people.map((c) => label(c)).join(', '),
  };
  if (meet) p.m = meet;
  return p;
}

/** Adresse complète : page publique + '#p=' + charge utile. */
export function proposalLink(base: string, payload: ProposalPayload): string {
  return base.replace(/#.*$/, '') + '#p=' + b64urlEncode(payload);
}

/** Lecture côté page publique. null si l’adresse ne porte pas de proposition ; lève une erreur si elle est altérée. */
export function decodeProposal(hash: string): ProposalPayload | null {
  const m = hash.match(/[#&]p=([A-Za-z0-9_-]+)/);
  if (!m) return null;
  const raw = b64urlDecode(m[1]!) as Partial<ProposalPayload> | null;
  if (!raw || typeof raw !== 'object' || !Array.isArray(raw.s) || !raw.s.length || !isValidZone(raw.z) || !(Number(raw.d) > 0)) {
    throw new Error('shape');
  }
  const s = raw.s.map(Number).filter((n) => Number.isFinite(n) && n > 0).slice(0, 8);
  if (!s.length) throw new Error('shape');
  const p: ProposalPayload = {
    v: 1,
    f: String(raw.f ?? ''),
    z: raw.z,
    c: String(raw.c ?? ''),
    e: String(raw.e ?? ''),
    d: Number(raw.d),
    s,
    t: String(raw.t ?? ''),
  };
  if (typeof raw.m === 'string' && /^https:\/\/\S+$/.test(raw.m)) p.m = raw.m;
  return p;
}
